import { render, staticRenderFns } from "./vigilante_parque.vue?vue&type=template&id=ee872e38&scoped=true"
import script from "./vigilante_parque.vue?vue&type=script&lang=js"
export * from "./vigilante_parque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee872e38",
  null
  
)

export default component.exports